import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import 'services/i18n/i18n';
import App from './App';
import * as serviceWorker from 'serviceWorker';
import './index.css';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
